import { Domain, DomainManagement } from './domain.model';
import { ActivityStatus } from './activity-status.model';
import { PaymentMethod } from './payment-method.enum';
import { PublisherStatus } from './publisher-status.enum';
import { KOCallStatus } from './ko-call-status.enum';
import { OnboardingStage } from './onboarding-stage.enum';
import { User } from './users/user.model';
import { IabContentTaxonomyT1 } from './iab-content-taxonomy.model';
import { BlockedDomainListRequest } from '../../kitchen/shared/domain/bd/blocked-domain-list-request.model';
import { ScaledPartnershipStatus } from './scaled-partnership-status.enum';
import { UnitWrapperType } from './unit-wrapper-type.enum';
import { IoExecutedStatus } from './io-executed-status.enum';
import { KeyValue } from './key-value.model';
import {App} from './app.model';
import {CxSupplyPartner} from './cx-supply-partner.model';

export class Publisher {

  id: string;
  name: string;
  companyId: string;
  domains: Domain[];
  cxSupplyPartners: CxSupplyPartner[];
  revenueShare: number;
  activityStatus: ActivityStatus;

  useTotalUnfilledImpressions: boolean;
  selfServed: boolean;
  confidential: boolean;
  condensedAdsTxt: boolean;
  ssIntroCompleted: boolean;
  salesRepresentative: string;
  salesRepresentativeEmail: string;
  accountManagerEmail: string;
  accountManagerName: string;
  appApprovalPolicy: string;

  tier: PublisherTier;

  // company info
  companyAddress: string;
  companyContactName: string;
  companyPhone: number;
  companyEmail: string;
  companyWebsiteUrl: string;
  companyCity: string;
  companyState: string;
  companyCountry: string;
  companyZipCode: string;
  company: string;

  // billing
  billingAddress: string;
  billingContactName: string;
  billingPhone: number;
  billingEmail: string;
  billingPayToName: string;

  // payment
  paymentMethod: PaymentMethod;
  paymentNameOnAccount: string;
  paymentBankName: string;
  paymentRoutingNumber: number;
  paymentAccountNumber: number;
  paymentAccountType: string;
  netPaymentTerms: number;
  createdOn: string;
  lastUpdatedOn: string;

  confiantPropertyId: string;
  confiantWrapperId: string;
  sellerType: string;

  w8FileId: string;
  w8Filename: string;
  w8FileUploadedBy: string;
  w8FileLink: string;

  dfpAdUnitId: string;
  dfpAdUnitCode: string;
  dfpAdUnitName: string;
  status: PublisherStatus;
  publisherDomains: Domain[];

  ioPdf: boolean;
  ioExecutedDate: string;
  ioExecutedStatus: IoExecutedStatus;
  ioRequested: boolean;
  initialDomains: string[];
  initialManagement: DomainManagement;

  scaledPartnershipStatus: ScaledPartnershipStatus;

  unitWrapperType: UnitWrapperType;
  loginEmailSent: boolean;
  siteListSubmitted: boolean;
  productsOrdered: boolean;
  orderSubmitted: boolean;
  unitWrapperTypes: string[];
  billingInfoCompleted: boolean;
  companyInfoCompleted: boolean;
  financeCompleted: boolean;
  cpmRevShareSet: boolean;

  koCallStatus: KOCallStatus;
  koCallStatusCompletedAt: string;

  mailSentOn: string;
  kickOffCallDate: string;
  contractCompletedOn: string;
  financeCompletedOn: string;
  demandPartners: string[];
  onboardingStage: OnboardingStage;

  bidderRevShare: number;
  adUnitRevshare: number;
  ioCpmDesktop: number;
  ioCpmMobile: number;
  pubmaticIdentifier: string;
  tipaltiId: string;
  tipaltiPayable: boolean;
  adstxtEmailReminder: boolean;
  iabCategory: IabContentTaxonomyT1;
  serverbidId: string;
  bidderEnabled: boolean;
  adTagEnabled: boolean;
  directAdsTxt: boolean;
  spmEligible: boolean;
  pubDashRevShareDisabled: boolean;
  serverbidSiteId: string;

  _filter: BlockedDomainListRequest;
  _selected: boolean;
  _expanded: boolean;
  _salesRepresentativeUser: User;

  _numDomainsPending: number;
  _numDomainsApproved: number;
  _numDomainsRejected: number;
  ext_lastUpdatedOnDays: number;
  mcmId: string;
  pipedriveLink: string;
  types: string[];
  promocastEnrolled: boolean;
  static of(id: string, name: string) {
    const publisher = new Publisher();
    publisher.id = id;
    publisher.name = name;
    return publisher;
  }
}

export class CountByOnboardingStage {
  stage: OnboardingStage;
  count: number;
}

export enum PublisherTier {
  TIER_1 = 'TIER_1',
  TIER_2 = 'TIER_2'
}

export const PublisherTierLabelMap = {
  TIER_1: 'Tier 1',
  TIER_2: 'Tier 2'
};

export const PublisherTierLabelMapKV = () =>
  (Object.keys(PublisherTier).map(key => new KeyValue(key, PublisherTierLabelMap[key])));

